export default function pricesForZone(prices, zone) {
  return prices.filter(function(price) {
    return parseInt(price.zone_no, 10) === zone;
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/pricing/pricesForZone.js